import React, { useRef } from 'react';
import html2canvas from 'html2canvas';
import { Button } from '@mui/material'

const TextToImage = ({ items }) => {
  const textContainerRef = useRef(null);

  const handleDownloadImage = async () => {
    if (textContainerRef.current) {
      // Convert the text container to a canvas
      const canvas = await html2canvas(textContainerRef.current);

      // Convert the canvas to an image
      const dataUrl = canvas.toDataURL('image/png');

      // Trigger a download
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = 'text-image.png';
      link.click();
    }
  };


  return (
    <div>
      {/* Hidden container for the text */}
      <div
        ref={textContainerRef}
        style={{
          position: 'absolute',
          top: '-9999px', // Place it off-screen
          left: '-9999px',
          padding: '20px',
          backgroundColor: '#fff',
          color: '#000',
          fontFamily: 'Arial, sans-serif',
          border: '1px solid #ccc',
        }}
      >
        <div style={{ width: 800, height: "100%", display: 'flex', flexDirection: 'column', alignItems: 'end' }}>
          <h1 style={{ textAlign: 'center' }} >الطلبات</h1>
          {items.map((text, index) => (
            <div key={index} style={{ margin: 0, fontSize: 18, lineHeight: 2, direction: 'rtl' }}>
              {`${index + 1}` + ".  " + text}
            </div>
          ))}
        </div>
      </div>

      {/* Button to download the image */}
      {items && items.length > 0 && <Button variant='contained' style={{ marginBottom: 10 }} onClick={handleDownloadImage}>
        Download Order
      </Button>}
    </div>
  );
};

export default TextToImage;
